<div>
  <mat-form-field appearance="standard">
    <mat-select [(value)]="currentLang" (selectionChange)="changeLanguage($event)">
      <mat-option [value]="'en'">En</mat-option>
      <mat-option [value]="'fr'">Fr</mat-option>
    </mat-select>
  </mat-form-field>
</div>
